/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Dispatch } from 'redux'

import { API } from '../api/api'
import { CANVAS } from '../helpers/constants'
import { fetch } from './../api/httpClient'
import ActionTypes from './actionTypes'

export const appAction =
  (data: any) =>
  (dispatch: Dispatch): void =>
    dispatch({
      type: ActionTypes.APP,
      data,
    })

export const messageAction = (data) => (dispatch) => {
  dispatch({
    type: ActionTypes.MESSAGE,
    data,
  })
}

export const uiStateAction = (data) => (dispatch) => {
  dispatch({
    type: ActionTypes.UI_STATE,
    data,
  })
}

export const schoolAction = (data) => (dispatch) => {
  dispatch({
    type: ActionTypes.SCHOOL,
    data,
  })
}

export const introspectAction = (data) => (dispatch) => {
  dispatch({
    type: ActionTypes.INTROSPECT,
    data,
  })
}

export const serviceProviderAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.SERVICEPROVIDER,
    data,
  })

export const enrolledProgramAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.ENROLLED_PROGRAMS,
    data,
  })

export const priorProgramAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.PRIOR_PROGRAMS,
    data,
  })
export const surveyDataAction = (data) => (dispatch) =>
  dispatch({
    type: ActionTypes.SURVEY_DATA,
    data,
  })

export const fetchServiceProviderCall = (successCallback, failureCallback) => async (dispatch) => {
  try {
    const apiPath = `${API.CORE.SERVICEPROVIDER}`
    const { data } = await fetch(apiPath)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
    dispatch(serviceProviderAction(data?.list?.find((item) => item.name === CANVAS)?.entityID))
  } catch (err) {
    if (typeof failureCallback === 'function') {
      failureCallback(err)
    }
  }
}
